 import Transitions from './modules/transitions.js';
 import Nav from './modules/nav.js';
 import Hexagones from './modules/hexagones.js';
 import Formulaire from './modules/formulaire.js';


function ready(fn)
{
	if(document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
    	fn();
  	} else {
    	document.addEventListener('DOMContentLoaded', fn);
	}
}
ready(init);


async function init()
{
	const plugins = [];
	if (typeof ScrollTrigger !== 'undefined') plugins.push(ScrollTrigger);
	if (typeof ScrollToPlugin !== 'undefined') plugins.push(ScrollToPlugin);
	if (typeof SplitText !== 'undefined') plugins.push(SplitText);
	if (typeof CSSRulePlugin !== 'undefined') plugins.push(CSSRulePlugin);
	if (plugins.length) gsap.registerPlugin.apply(gsap, plugins);

	const transitions = new Transitions();
	window.guildeTransitions = transitions;
	const nav = new Nav();
	

	if (document.querySelector('.carrousel-slider') || document.querySelector('.jeux-slider')) {
        const { default:Slider } = await import('./modules/slider.js');
        const slider = new Slider();
    }

	if (document.querySelector('.split-text-content h2, .split-text-content h3, body.gfq h1')) {
        const { default:SplitChar } = await import('./modules/splitchar.js');
        const splitChar = new SplitChar();
    }

	if (document.querySelector('#map')) {
        const { default:Map } = await import('./modules/map.js');
        const map = new Map();

		if (document.querySelector(".filtres li .sub-container")) {
			const { default:Repertoire } = await import('./modules/repertoire.js');
			const repertoire = new Repertoire(map);
		}
    }

	if (document.querySelector(".row_roulette .liste-mots")) {
        const { default:Roulette } = await import('./modules/roulette.js');
        const roulette = new Roulette();
    }

	if (document.querySelector(".team-member") || document.querySelector('.liste-equipe')) {
        const { default:Equipe } = await import('./modules/equipe.js');
        const equipe = new Equipe();
    }

	if(document.querySelector(".row_liste_nouvelles")) {
        const { default:Nouvelles } = await import('./modules/nouvelles.js');
        const nouvelles = new Nouvelles();
    }
	
	if(document.querySelector(".row_liste_initiatives")) {
        const { default:Initiatives } = await import('./modules/initiatives.js');
        const nouvelles = new Initiatives();
    }

	if (document.querySelector('.row_liste_fiches')) {
		const { default: Fiches } = await import('./modules/fiches.js');
		new Fiches();
	}

	if (document.querySelector('.row_accordeons') || document.querySelector('.row_liste_fiches')) {
		const { default: Accordeons } = await import('./modules/accordeons.js');
		window.guildeAccordeons = new Accordeons();
	}

	if (document.querySelector('.row_media')) {
		const { default: MediaVideo } = await import('./modules/media-video.js');
		window.guildeMediaVideo = new MediaVideo();
	}

	if(document.querySelector(".corde-haut")) {
		const { default:Corde } = await import('./modules/corde.js');
		const corde = new Corde();
	}

	if (document.querySelector('.gfq-header')) {
		const { default: GfqMenu } = await import('./modules/gfq-menu.js');
		new GfqMenu();
	}

	if (document.querySelector('.row_repertoire_jeux, .gfq-overlay, .gfq-hero, .row_prochaines_sorties')) {
		const { default: GfqDirectory } = await import('./modules/gfq-directory.js');
		window.gfqDirectoryApp = new GfqDirectory();
	}

	if (document.querySelector('.row_prochaines_sorties')) {
		const { default: SortiesTicker } = await import('./modules/sorties-ticker.js');
		new SortiesTicker();
	}
	
	const formulaire = new Formulaire();
	if (!document.body.classList.contains('gfq')) {
		const hexagones = new Hexagones();
	}

	initLenis();
	
	//window.addEventListener("resize", resizeHandler);
	//resizeHandler();
}


function initLenis()
{
	const lenis = new Lenis({
		prevent: (node) => !!(node && node.closest && node.closest('.gfq-overlay')),
		touchMultiplier: 0
	});
	window.guildeLenis = lenis;

	if (document.body.classList.contains('gfq-overlay-open') && lenis.stop) {
		lenis.stop();
	}

	lenis.on('scroll', (e) => {
		//console.log(e);
	})

	lenis.on('scroll', ScrollTrigger.update);

	gsap.ticker.add((time)=>{
		lenis.raf(time * 1000);
	})

	gsap.ticker.lagSmoothing(0);

	const mapEl = document.querySelector('#map');
	if (mapEl) {
		mapEl.addEventListener('wheel', (e) => {
			if (e.metaKey || e.ctrlKey) {
				e.stopPropagation();
				e.preventDefault();
			}
		}, { passive: false });
	}
}


function resizeHandler(e)
{
	// mediaQuery = window.matchMedia('(min-width: 768px)');
	// if (mediaQuery.matches) {
	// 	gsap.matchMediaRefresh();
	// }
}